import { cn } from '../../lib/cn';

interface Stage {
  id: string;
  name: string;
  color?: string;
}

interface StageProgressBarProps {
  stages: Stage[];
  currentStageId: string;
  className?: string;
}

export function StageProgressBar({ stages, currentStageId, className }: StageProgressBarProps) {
  const currentIndex = stages.findIndex((s) => s.id === currentStageId);

  return (
    <div className={cn('flex items-center gap-1', className)}>
      {stages.map((stage, index) => {
        const isCompleted = index < currentIndex;
        const isCurrent = index === currentIndex;

        return (
          <div key={stage.id} className="flex flex-1 flex-col items-center gap-1.5">
            {/* Bar segment */}
            <div className="flex w-full items-center">
              <div
                className={cn(
                  'h-2 w-full rounded-full transition-colors',
                  isCompleted
                    ? 'bg-brand-500'
                    : isCurrent
                      ? 'bg-brand-400'
                      : 'bg-surface-200',
                )}
                style={
                  (isCompleted || isCurrent) && stage.color
                    ? { backgroundColor: stage.color }
                    : undefined
                }
              />
            </div>

            {/* Dot and label */}
            <div className="flex flex-col items-center">
              <div
                className={cn(
                  'h-3 w-3 rounded-full border-2 transition-colors',
                  isCompleted
                    ? 'border-brand-500 bg-brand-500'
                    : isCurrent
                      ? 'border-brand-500 bg-white'
                      : 'border-surface-300 bg-white',
                )}
                style={
                  isCompleted && stage.color
                    ? { borderColor: stage.color, backgroundColor: stage.color }
                    : isCurrent && stage.color
                      ? { borderColor: stage.color }
                      : undefined
                }
              />
              <span
                className={cn(
                  'mt-1 text-2xs font-medium',
                  isCurrent ? 'text-slate-900' : 'text-slate-400',
                )}
              >
                {stage.name}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
}
